module.exports = __webpack_public_path__ + "img/ArgCroacia4.d9d398a2.jpg";